<template>
  <div class="emd-container__header -eu-mx_1">
    <slot></slot>
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: 'EmdCardHeader'
}
</script>

<style scoped>
.-eu-mx_1 {
  margin: -2px -2px 0;
}
</style>
